import { EmailIcon, FlagIcon, PhoneIcon } from "@xola/icons";
import React from "react";
import { Purchase } from "types";
import { getCustomerName } from "@/models/Purchase";

interface CustomerInfoHeaderProps {
    purchase: Purchase;
}

export const CustomerInfoHeader = ({ purchase }: CustomerInfoHeaderProps) => {
    return (
        <div className="w-75 space-y-0.5 bg-gray-lighter p-5 pt-2.5">
            <div className="text-lg font-bold">
                <FlagIcon size="medium" className="text-warning" /> {getCustomerName(purchase)}
            </div>

            <div className="space-y-1 text-gray-darker">
                {purchase.phone ? (
                    <div>
                        <PhoneIcon /> {purchase.phone}
                    </div>
                ) : null}

                {purchase.customerEmail ? (
                    <div>
                        <EmailIcon /> {purchase.customerEmail}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
